module.exports = __webpack_public_path__ + "static/media/reglamento_1.b1060751.png";